export enum ForgotStep {
  main,
  registerNewPassword,
  registerNewPin,
}
